<template>
		<div class="p-4">
			<Steps :currentStep="2"></Steps>
		</div>
		<ClientData></ClientData>
</template>

<script>
import ClientData from '../../Widgets/Contracts/NewContract/ClientData/ClientData.vue';
import Steps from '../../Widgets/Contracts/NewContract/Steps/Steps.vue';
export default {
  name: 'NewContractStep2',
  components: {
    ClientData,
    Steps,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>